import { webApiEndpoints } from "../config";
import { setMultipartImage } from "../helpers/form.helper";
import secureHelper from "../helpers/secure.helper";
import util from "../helpers/util.helper";
import { ApiSaenvProfileResp, ApiSarenvProfile, ApiSartokenRequest, AppCategories, AppRequestType, CredentialJiraType, CurpProfile, SarEnvFederalState, SarEnvProfile, UserDocumentFile } from "../types";

const os = util.detectOS()

const category: AppCategories = 'sarenv'

export const sarenvAdapter = {

    validateCurp: (curp: string): AppRequestType<CurpProfile>['thirdParty']['validarCurp'] => ({
        endpoint: webApiEndpoints['thirdParty'].validarCurp,
        input: setSartokenEnvelope(curp, { curp }),
        isSuccesful: response => response.data.code === '01',
        handleErrorMessage: (response) => {
            console.log(response)
            if (response.data.code === '02') {
                return response.data.message
            }
            return 'Ocurrio un error al invocar el servicio'
        },
        output: ({ output }) => ({
            birthDate: output["fecha-nacimiento"],
            birthFederalState: output["clave-entidad"],
            curp,
            gender: output.sexo,
            lastName: output["apellido-paterno"].toUpperCase(),
            secondLastName: output["apellido-materno"]?.toUpperCase(),
            name: output.nombre.toUpperCase(),
            nacionality: output["clave-nacionalidad"],
        })
    }),


    getFederalStates: (): AppRequestType<SarEnvFederalState[]>['thirdParty']['consultarCatalogoEstados'] => ({
        endpoint: webApiEndpoints['thirdParty'].consultarCatalogoEstados,
        input: setSartokenEnvelope('', {
            "nombre-catalogo": 'entidad-federativa'
        }),
        isSuccesful: response => response.data.code === '01',
        output: ({ output }) => {
            return output.dataSet.map(item => ({
                alphabeticCode: item.campos.claveAlfabetica,
                code: item.campos.clave,
                id: item.id.toString(),
                name: item.nombre
            }))
        }
    }),

    enviromentProfile: async (enviromentType: string, userData: SarEnvProfile, userDocuments: UserDocumentFile[]): Promise<AppRequestType<ApiSaenvProfileResp>[typeof category]['ambientacionPerfil']> => {
        const formData = await setMultipartImage(userDocuments)
        let inputData: ApiSarenvProfile = {
            apellidoMaterno: userData.secondLastName,
            apellidoPaterno: userData.lastName,
            curp: userData.curp,
            cvEntNac: userData.birthFederalState,
            fechaNacimiento: userData.birthDate.split('/').reverse().join(""),
            cvNacion: "1",
            nombre: userData.name,
            sexo: userData.gender === 'H' ? 'M' : 'F',
            tipoAmbientacion: enviromentType,
            nss: userData.nss,
            cvAfore: userData.aforeCode,
            nombreImss: userData.imssName,
            email: userData.email,
            celular: userData.phoneNumber,
        }
        formData.append("input", secureHelper.encriptApiRequest(JSON.stringify(inputData), process.env.REACT_APP_CYPHER || ''))
        return {
            endpoint: webApiEndpoints[category].ambientacionPerfil,
            input: formData,
            output: (data) => data
        }
    }

}

function setSartokenEnvelope<T>(curp: string, input: T): ApiSartokenRequest<T> {
    return {
        device: {
            "date-time": util.setDateFormat(new Date(), 'YYYY-MM-DD HH24:MI:SS'),
            "geo-location": "0.0,0.0",
            appVersion: '2.20',
            language: 'es-MX',
            model: os,
            name: navigator.userAgent.substring(0, 10),
            os: "Web",
            sdkVersion: "1.0.0",
            uuid: "AforeWeb"
        },
        identity: {
            "client-id": curp,
            "client-secret": "s7M3gWtNw7hJklN6",
            "project-id": "mx.com.procesar.aforeweb",
        },
        input
    }
}